<template>
  <div id="modalCreateEditLesson" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Aula</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body pb-1">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Título: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.lesson.title.$errors.length }"
                  placeholder="Título da Aula"
                  v-model="v$.lesson.title.$model"
                />
                <span
                  v-if="v$.lesson.title.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.lesson.title.minLength.$invalid"
                  class="invalid-feedback"
                >
                  O título deve possuir pelo menos
                  {{ v$.lesson.title.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-sm-12">
                <label class="form-label">
                  Descrição: <span class="text-danger">*</span>
                </label>
                <textarea
                  class="form-control"
                  :class="{
                    'is-invalid': v$.lesson.description.$errors.length,
                  }"
                  placeholder="Descrição da Aula"
                  rows="3"
                  v-model="v$.lesson.description.$model"
                />
                <span
                  v-if="v$.lesson.description.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-12">
                <label class="form-label">
                  Tipo de Aula: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{ 'is-invalid': v$.lesson.type.$errors.length }"
                  v-model="v$.lesson.type.$model"
                  :disabled="lessonId"
                >
                  <option value="">Selecione o tipo de Aula</option>
                  <option value="1">Vídeo</option>
                  <option value="2">Quiz</option>
                  <option value="3">Texto</option>
                </select>
                <span
                  v-if="v$.lesson.type.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <div
                  v-if="!lessonId && lesson.type == 2"
                  class="alert alert-primary border-0 mt-3 mb-0 p-2"
                >
                  <small>
                    <strong>Atenção</strong>: Após cadastrar a aula do tipo
                    "Quiz" é necessário cadastrar as questões!
                  </small>
                </div>
              </div>
              <div v-if="lesson.type == 1" class="col-sm-12">
                <label class="form-label">
                  Link: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.lesson.link.$errors.length }"
                  placeholder="Link do Vídeo"
                  v-model="v$.lesson.link.$model"
                />
                <span
                  v-if="v$.lesson.link.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.lesson.link.url.$invalid"
                  class="invalid-feedback"
                >
                  Formato de URL inválido
                </span>
              </div>
              <div v-if="lessonId" class="col-sm-6">
                <p>Status: <span class="text-danger">*</span></p>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="statusInativo"
                    value="0"
                    v-model="lesson.status"
                  />
                  <label class="form-check-label" for="statusInativo">
                    Inativo
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="statusAtivo"
                    value="1"
                    v-model="lesson.status"
                  />
                  <label class="form-check-label" for="statusAtivo">
                    Ativo
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, requiredIf, url } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditLessonModal',

  props: {
    courseId: {
      type: String,
      required: true,
    },
    moduleId: {
      type: String,
      required: true,
    },
    lessonId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      lesson: {
        title: '',
        description: '',
        type: '',
        link: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.lessonId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getLesson() {
      try {
        this.lesson = await this.$store.dispatch('getLesson', {
          courseId: this.courseId,
          moduleId: this.moduleId,
          lessonId: this.lessonId,
        })
        showModal('modalCreateEditLesson')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.lessonId) {
            response = await this.$store.dispatch('updateLesson', {
              courseId: this.courseId,
              moduleId: this.moduleId,
              lessonId: this.lessonId,
              lesson: this.lesson,
            })
          } else {
            response = await this.$store.dispatch('saveLesson', {
              courseId: this.courseId,
              moduleId: this.moduleId,
              lesson: this.lesson,
            })
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      lesson: {
        title: {
          required,
          minLength: minLength(4),
        },
        description: {
          required,
        },
        type: {
          required,
        },
        link: {
          required: requiredIf(() => {
            return this.lesson.type === '1'
          }),
          url,
        },
      },
    }
  },

  mounted() {
    if (this.lessonId) {
      this.getLesson()
    } else {
      showModal('modalCreateEditLesson')
    }
  },
}
</script>
